import React from "react";
import { Box, Typography } from "@mui/material";
import { C } from "../constants/colors";

export function BrandMark({ size = 36 }) {
  const id = React.useId().replace(/:/g, "");
  const gradId = `apb-grad-${id}`;
  const s = size;

  return (
    <Box
      component="svg"
      width={s}
      height={s}
      viewBox="0 0 40 40"
      aria-hidden
      sx={{ display: "block", flexShrink: 0, borderRadius: `${Math.round(s * 0.28)}px` }}
    >
      <defs>
        <linearGradient id={gradId} x1="4" y1="36" x2="36" y2="4" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#173673" />
          <stop offset="45%" stopColor="#2E6BE6" />
          <stop offset="100%" stopColor="#3377FF" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="11" fill={`url(#${gradId})`} />
      <path
        d="M7.5 29.5C11.5 29.5 13.2 26.2 15.5 23.5C18.2 20.4 20.8 18.2 24.2 15.2C26.6 13.1 28.8 11.2 32.2 9.2"
        fill="none"
        stroke="rgba(255,255,255,0.92)"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <circle cx="8" cy="29.5" r="3.1" fill="#EAF0FF" />
      <circle cx="8" cy="29.5" r="1.35" fill="#2E6BE6" />
      <circle cx="16.2" cy="22.6" r="2.55" fill="#fff" />
      <circle cx="24.5" cy="15.4" r="2.55" fill="#fff" />
      <circle cx="32.2" cy="9.4" r="4.4" fill="#2E6BE6" />
      <path
        d="M32.2 6.7L32.85 8.55L34.85 9.15L32.85 9.75L32.2 11.6L31.55 9.75L29.55 9.15L31.55 8.55Z"
        fill="#fff"
      />
    </Box>
  );
}

export default function BrandLogo({
  size = 36,
  showWordmark = true,
  showTagline = false,
  wordmarkSize = 15,
  compact = false,
  inverted = false,
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
      <BrandMark size={size} />
      {showWordmark && !compact && (
        <Box sx={{ minWidth: 0, lineHeight: 1.1 }}>
          <Typography
            component="span"
            sx={{
              display: "block",
              fontWeight: 700,
              fontSize: wordmarkSize,
              color: inverted ? "#fff" : C.text,
              letterSpacing: "-0.03em",
            }}
          >
            AI Path Builder
          </Typography>
          {showTagline && (
            <Typography
              component="span"
              sx={{
                display: "block",
                fontSize: 12,
                fontWeight: 500,
                color: inverted ? "rgba(255,255,255,0.75)" : C.muted,
                letterSpacing: "0.02em",
                mt: 0.25,
              }}
            >
              Plan · Learn · Build
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
